"use client";

import React, { useState } from 'react';
import DarkLocationsIcon from "@/components/icons/DarkLocationsIcon";
import dynamic from "next/dynamic";

const LocationDialogue = dynamic(
    () => import("@/app/profile/components/LocationDialogue"),
    {ssr: false}
)

const LocationSwitcher = () => {
  const [dialogueOpen, setDialogueOpen] = useState(false);

  const openDialogue = () => {
    setDialogueOpen(true);
  };

  const closeDialogue = () => {
    setDialogueOpen(false);
    window.location.reload();
  };

  return (
      <div onClick={openDialogue} style={{ cursor: 'pointer' }}>
        <DarkLocationsIcon />
        {dialogueOpen &&
          <LocationDialogue
              open={dialogueOpen}
              onClose={closeDialogue}
          />
        }
      </div>
  );
};

export default LocationSwitcher;
